import React from 'react';
import { FormControlLabel, Checkbox } from '@mui/material';

interface GroupToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

const GroupToggle: React.FC<GroupToggleProps> = ({
  checked,
  onChange,
  disabled = false,
}) => {
  return (
    <FormControlLabel
      data-testid="group-toggle"
      control={
        <Checkbox
          data-testid="group-toggle-input"
          checked={checked}
          onChange={e => onChange(e.target.checked)}
          disabled={disabled}
        />
      }
      label="Group"
      sx={{
        ml: '4px',
        opacity: disabled ? 0.6 : 1,
      }}
    />
  );
};

export default GroupToggle;
